export const inspectionReport = {
  criticalItemFailed: "关键项未通过",
  fleet: "车间",
  make: "品牌",
  model: "型号",
  nonCriticalItemFailed: "非关键项未通过",
  passed: "通过",
  reliability: "可靠性",
  submittedAt: "提交时间",
  submittedBy: "提交者",
  uninspected: "未点检",
  vehicle: "设备",
  InspectionNotes: "点检备注",
  Notes: "查看备注",
  inspected: "已点检",
};
